export default __webpack_public_path__ + "static/media/back_icon.042a5422.svg";